import React from 'react';
import Table from '../../components/subcomponents/table'
import TableControl from '../../components/subcomponents/table_control'
import { connect } from 'react-redux'
import logs from '../../api/logs'
import notification from '../../components/subcomponents/notification'
import SubformDetails from '../../components/subcomponents/subform_details'

class LogControllers extends React.Component{
    componentWillMount() {
        logs.log_controllers(function(error, response) {
            if (error) {
                notification.error(error.message);
            }
        });

    }
    render() {
        return (
            <SubformDetails title='LOG CONTROLLERS' className="details width_100">
                <TableControl search={this.props.search_string}
                              handleSearch={this.props.handleSearch}
                              navigation={this.props.navigation}
                              handleSetRPP={this.props.handleSetRPP}
                              handleSetPage={this.props.handleSetPage}/>
                <Table name="log_controllers_list" table_key={'log_controllers_id'}
                       headers={{time: {label: 'Time'}, controller_mac: {label: 'Controller MAC'}, state: {label: 'State'}, reboot: {label: 'Reboot'}, channel: {label: 'Channel'}}}
                       col_width={{time: '15%', controller_mac: '25%', state: '30%', reboot: '20%', channel: '10%'}}
                       data={this.props.log_controllers_list}/>
            </SubformDetails>
        )
    }
}

function mapStateToProps(state) {
    let log_controllers = state.logsR.log_controllers;
    return {
        search_string: log_controllers.search_string,
        navigation: log_controllers.list_pagination,
        log_controllers_list: log_controllers.list,

    }
}

function mapDispatchToProps(dispatch) {
    return({
        handleSearch(result) {
            dispatch({
                type: "LOG_CONTROLLERS_UPDATE_SEARCH_STRING",
                value: result.value
            });
            logs.log_controllers(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        },
        handleSetRPP(result) {
            dispatch({
                type: 'LOG_CONTROLLERS_RPP_CHANGED',
                value: result.value
            });
            logs.log_controllers(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        },
        handleSetPage(value) {
            dispatch({
                type: 'LOG_CONTROLLERS_SET_PAGE',
                value: value
            });
            logs.log_controllers(function(error, response) {
                if (error) {
                    notification.error(error.message);
                }
            });
        }
    })
}

export default LogControllers = connect(
    mapStateToProps, mapDispatchToProps)(
        LogControllers
);